import * as React from 'react';
import { useRef } from 'react';
import ReactTooltip from 'react-tooltip';

function downloadTextAsSVG(name, svg) {
    const blob = new Blob([svg], { type: 'image/svg+xml' });

    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${name}.svg`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

type SvgIconOptionProps = {
    value: string;
    label: string;
    tooltip: string;
    tooltipId: string;
    onChange: (svgContent: string) => void;
    onReset: () => void;
    className?: string;
    iconWidth?: number
    iconHeight?: number
    tooltipEndMsg?: string
}

export function SvgIconOption({ className, label, value, onChange, onReset, tooltip, tooltipId, iconWidth, iconHeight, tooltipEndMsg = '' }: SvgIconOptionProps) {

    const fileInputRef = useRef<HTMLInputElement>();

    const openDialogCb = () => {
        fileInputRef.current.click();
    }

    const onLoad = () => {
        downloadTextAsSVG(label, value)
    }

    const onFileChangedCb = (e) => {
        const file = fileInputRef.current.files[0];
        const reader = new FileReader();
        e.target.value = null;

        reader.onload = function (event) {
            const svgContent = event.target.result;
            onChange(svgContent as string);
        };

        reader.readAsText(file);
    }

    const iconInfo = `The icon must be in SVG format and should fit within a rectangle of ${iconWidth}(w)x${iconHeight}(h) pixels or less. This ensures consistency in the appearance of icons across the app.`;

    return <div className="text-chat-options_table_row">
        <div className={`text-chat-options_two-parts-holder ${className}`}>
            <span className="text-chat-options_label"
                data-place="bottom"
                data-multiline="true"
                data-effect="solid"
                data-offset="{'top': -20}"
                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240 text-chat-option-tooltip"
                data-for={tooltipId}
                data-tip={`${tooltip}<br/><br/>${iconInfo}${tooltipEndMsg && `<br/><br/>${tooltipEndMsg}`}`}>{label}<i style={{ position: 'relative', top: '2px', left: '4px' }} className="icon icon-alan-info-sign" /></span>
            <div style={{ display: 'flex', gap: '8px', height: '30px', minWidth: '164px' }}>
                <div className="action-btn light-blue-with-border" style={{ height: '100%', width: '100%' }} onClick={openDialogCb}>Upload</div>
                {value && <div className="action-btn light-blue-with-border" style={{ height: '100%', width: '32px', minWidth: '32px', display: 'flex' }} onClick={onLoad}><i style={{ margin: '0' }} title='Download' className='icon icon-alan-load-down' /></div>}
                {value && <div className="action-btn light-red-with-border" style={{ height: '100%', width: '32px', minWidth: '32px', display: 'flex' }} onClick={onReset}><i style={{ margin: '0' }} title='Remove' className='icon icon-alan-trash' /></div>}
            </div>
            <ReactTooltip id={tooltipId} />
            <input style={{ display: 'none' }} type="file" ref={fileInputRef} onChange={onFileChangedCb} accept=".svg" />
        </div>
    </div>;
}